import React from 'react';

const TokenContext = React.createContext<string | null>(null);

export default TokenContext;
